import Api from '@/services/api';
import qs from 'querystring';

export default {
  search(params, filters = [], hiddenFilter = '', page = 1, sortBy = 'name', sortDesc = false, fetchFacets = true) {

    return Api().post('/prospect/search', qs.stringify({
      'search': JSON.stringify(params),
      'filters': JSON.stringify(filters),
      'hiddenFilter': hiddenFilter,
      'page': page,
      'sortBy': sortBy,
      'sortDesc': sortDesc,
      'fetchFacets': fetchFacets
    }));
  },
  delete_prospect(data) {
    return Api().delete('/prospect/' + data.prospect_id );
  },
  update_prospect(data) {
    return Api().post('/prospect/' + data.prospect_id , qs.stringify({ data: JSON.stringify(data.prospect) }));    
  },
  create_creditor(data) {
    return Api().post('/prospect/' + data.prospect_id + '/create-creditor');    
  },
  create_prospect(data) {
    return Api().post('/prospect', qs.stringify({ data: JSON.stringify(data.prospect) }));    
  },
  import_prospect(data) {
    return Api().post('/prospect/import/' + encodeURIComponent(data.activity) + '/' + encodeURIComponent(data.locality) + '/' + encodeURIComponent(data.nego),
    qs.stringify({
      'options': JSON.stringify(data.options)
    }));
  },
  prospect(data) {
    return Api().get('/prospect/' + data.prospect_id);
  },
  categories() {
    return Api().get('/prospect/categories');
  }
}